module.exports = __webpack_public_path__ + "static/media/regularlyPerform.5fb89168.svg";